import { render, staticRenderFns } from "./JobylonIcon.vue?vue&type=template&id=31b6385c&scoped=true&"
import script from "./JobylonIcon.vue?vue&type=script&lang=ts&"
export * from "./JobylonIcon.vue?vue&type=script&lang=ts&"
import style0 from "./JobylonIcon.vue?vue&type=style&index=0&id=31b6385c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6385c",
  null
  
)

export default component.exports